import { render, staticRenderFns } from "./ClientesPrincipal.vue?vue&type=template&id=4bbb28a8&scoped=true&"
import script from "./ClientesPrincipal.vue?vue&type=script&lang=js&"
export * from "./ClientesPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./ClientesPrincipal.vue?vue&type=style&index=0&id=4bbb28a8&lang=scss&scoped=true&"
import style1 from "./ClientesPrincipal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbb28a8",
  null
  
)

export default component.exports